import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-error-modal',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <div class="error-modal">
      <div class="modal-header">
        <h2 class="modal-title">{{ data.title || 'Error' }}</h2>
      </div>

      <div class="modal-content">
        <div class="icon-container">
          <mat-icon class="error-icon">error</mat-icon>
        </div>
        <div class="message-container">
          <p class="main-message">{{ data.mainMessage }}</p>
          <p class="sub-message">{{ data.subMessage }}</p>
        </div>
      </div>

      <div class="modal-actions">
        <button mat-raised-button class="close-button" (click)="onClose()">Cerrar</button>
      </div>
    </div>
  `,
  styles: [
    `
      .error-modal {
        background: white;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
        min-width: 400px;
        max-width: 500px;
      }

      .modal-header {
        background: #f44336;
        color: white;
        padding: 16px 20px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);

        .modal-title {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
        }
      }

      .modal-content {
        padding: 24px 20px;
        text-align: center;

        .icon-container {
          margin-bottom: 16px;

          .error-icon {
            font-size: 48px;
            width: 48px;
            height: 48px;
            color: #f44336;
          }
        }

        .message-container {
          .main-message {
            margin: 0 0 8px 0;
            font-size: 16px;
            font-weight: 600;
            color: #333;
          }

          .sub-message {
            margin: 0;
            font-size: 14px;
            color: #666;
            line-height: 1.4;
          }
        }
      }

      .modal-actions {
        padding: 16px 20px;
        background: #f8f9fa;
        border-top: 1px solid #e9ecef;
        display: flex;
        justify-content: center;

        .close-button {
          background: #f44336;
          color: white;

          &:hover {
            background: #d32f2f;
          }
        }
      }
    `
  ]
})
export class ErrorModalComponent {
  private readonly dialogRef = inject(MatDialogRef<ErrorModalComponent>);
  public readonly data = inject(MAT_DIALOG_DATA) as {
    title?: string;
    mainMessage: string;
    subMessage: string;
  };

  onClose(): void {
    this.dialogRef.close();
  }
}
